<template>
  <div>

    <steps-order
      :step=3
    ></steps-order>

    <section class="invoice cartStyle choixModePayement">
      <!-- title row -->
      <div class="row">
        <div class="col-xs-12">
          <h2 class="page-header">
            <i class="fa fa-shopping-cart"></i> Choisissez votre mode de payement
          </h2>
        </div>
      </div>
      <div class="row choixModePayement">
        <div class="col-md-12">

          <div class="checkbox">
            <label class="checkbox-inline" style="font-weight: 400;">
              <input id="affichage_correspondantTrue" type="checkbox"
                     v-model="facturationAdresse">
              Mon adresse de facturation est différente de mon adresse de livraison.
            </label>
            <i class="fa fa-info-circle"
               v-tooltip.top-center="`Cliquez ici si vous souhaitez que votre commande soit facturée à une autre adresse.`">
            </i>
          </div>
        </div>
        <b-collapse visible v-model="facturationAdresse"
                    style="margin-top: 20px;" class="">
          <b-card>
            <form data-vv-scope="formFacturationAdresse" @submit.prevent="">
              <div class="row" v-if="true">
                <div class="col-md-12">
                  <div class="form-group" :class="{'has-error': errors.has('mail') }">
                    <label for="mail">E-mail:</label>
                    <input class="form-control" type="text" v-validate="'required|email'" v-model="adresse.mail"
                           id="mail" name="mail">
                    <span v-show="errors.has('mail')" class="help-block">Adresse mail incorrecte</span>
                  </div>
                  <div class="form-group" :class="{'has-error': errors.has('nom') }">
                    <label for="nom">Nom:</label>
                    <input class="form-control" type="text" v-validate="'required|min:2|max:255'"
                           v-model="adresse.nom" id="nom" name="nom">
                    <span v-show="errors.has('nom')"
                          class="help-block">Le nom doit comporter entre 2 et 255 caractères</span>

                  </div>
                  <div class="form-group" :class="{'has-error': errors.has('prenom') }">
                    <label for="prenom">Prénom:</label>
                    <input class="form-control" type="text" v-validate="'required|min:2|max:255'"
                           v-model="adresse.prenom" id="prenom" name="prenom">
                    <span v-show="errors.has('prenom')" class="help-block">Le prénom doit comporter entre 2 et 255 caractères</span>

                  </div>

                  <div class="form-group" :class="{'has-error': errors.has('adresse') }">
                    <label for="adresse">N° et nom de rue:</label>
                    <input class="form-control" type="text" v-validate="'required|min:1|max:512'"
                           v-model="adresse.adresse" id="adresse" name="adresse">
                    <span v-show="errors.has('adresse')" class="help-block">L'adresse ne peut être vide et doit comporter moins de 512 caractères</span>

                  </div>

                  <div class="form-group" :class="{'has-error': errors.has('complement') }">
                    <label for="adresse">Complément d’adresse:</label>
                    <input class="form-control" type="text" v-validate="'max:512'" v-model="adresse.complement"
                           id="complement" name="complement">
                    <span v-show="errors.has('complement')" class="help-block">Le complément doit comporter moins de 512 caractères</span>

                  </div>

                  <div class="form-group" :class="{'has-error': errors.has('cp') }">
                    <label for="cp">Code postal:</label>
                    <input class="form-control" type="text" v-validate="'required|min:4|max:5'" v-model="adresse.cp"
                           id="cp" name="cp">
                    <span v-show="errors.has('cp')" class="help-block">Le code postal n'est pas valide</span>
                  </div>

                  <div class="form-group" :class="{'has-error': errors.has('ville') }">
                    <label for="nom">Ville:</label>
                    <input class="form-control" type="text" v-validate="'required|min:2|max:255'"
                           v-model="adresse.ville" id="ville" name="ville">
                    <span v-show="errors.has('ville')" class="help-block">Le nom de la ville doit comporter moins de 255 caractères</span>
                  </div>

                  <div class="form-group" :class="{'has-error': errors.has('tel') }">
                    <label for="tel">Téléphone / GSM:</label>
                    <input class="form-control" type="text" v-validate="'max:25'" v-model="adresse.telephone_gsm"
                           id="tel" name="tel">
                    <span v-show="errors.has('club[tel]')" class="help-block">Numéro de téléphone incorrect</span>
                  </div>

                </div>
              </div>
            </form>
          </b-card>

        </b-collapse>

      </div>
      <!-- Table row -->
      <div class="row choixModePayement">

        <div class="col-md-12 ">
          <div class="col-md-1">
            <div class="check" @click.prevent="checkVirement()">
              <div class="checkInside" v-if="modePayement=='virement'">
                <span class="fa fa-check" style="color:white"></span>
              </div>
            </div>
            <!--              <input type="checkbox" :checked="livraisonByAdresse" value="adresse" name="deliveryType" class="hidden-radio">-->
          </div>
          <div class="col-md-11">
            <div @click.prevent="checkVirement()" class="info-box-content">
              <span class="info-box-number">Payer par virement bancaire</span>
              <span class="technical-hide-when-opened" style="display: inline;">
               Le formulaire de paiement sera envoyé par mail à la confirmation de votre commande</span>
            </div>
          </div>
        </div>

        <br>
        <div class="col-md-12">
          <hr>
        </div>

        <div class="col-md-12 " v-if="!stripeOutOfService">
          <div class="col-md-1">
            <div class="check" @click.prevent="checkPayementElectronique('card')">
              <div class="checkInside" v-if="modePayement=='payementElectronique' && sousModePayement=='card'">
                <span class="fa fa-check" style="color:white"></span>
              </div>
            </div>
          </div>
          <div class="col-md-11">
            <div @click.prevent="checkPayementElectronique('card')" class=" info-box-content">
              <span class="info-box-number">Paiement électronique sécurisé</span>
              <div class="technical-hide-when-opened" style="display: inline;">
                Payer par VISA, Mastercard, American Express ou Carte bleue
                <div class="iconsPaymentMethodCard">
                  <img src="../../assets/img/icons/icon_checkout_visa.png">
                  <img src="../../assets/img/icons/icon_checkout_mastercard.png">

                  <img src="../../assets/img/icons/icon_checkout_americanexpress.png">
                  <img src="../../assets/img/icons/icon_checkout_cartebleue.png">
                  <!--                  <img src="../../assets/img/icons/icon_checkout_paypal.png">-->
                </div>
                <div>
                  <img src="../../assets/img/logos/powered_by_stripe.png" style="margin-top: 10px;" alt="">
                </div>
                <span style="color: #7c7c7c; font-size: 12px  ;">
                  Tous les paiements électroniques sont effectués via notre partenaire Stripe via une connexion SSL sécurisée.<br/>
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-12 credit_card">
            <b-collapse visible v-model="modePayementIsElectronique" style="margin-top: 20px;"
                        class="">
              <b-card>
                <form data-vv-scope="errorsCard" @submit.prevent="">
                  <div class="col-md-12">
                    <div class="panel panel-default credit-card-box">
                      <div class="panel-heading display-table">
                        <div class="display-tr">
                          <h3 class="panel-title display-td">Informations de payement</h3>
                          <span class="small">Ces données ne transitent pas via les serveurs de l'A.B.F.T.
                          Nous n'enregistrons aucune donnée liée à votre moyen de payement.</span>
                        </div>
                      </div>
                      <div class="panel-body">

                        <div class="col-xs-12 card-element">
                          <div class="form-group"
                               :class="{'has-error': titulName!=null && errors.has('errorsCard.titulName') }">
                            <label for="titulName">Nom du titulaire de la carte</label>
                            <input
                              type="text"
                              ref="titulName"
                              id="titulName"
                              v-model="titulName"
                              class="field empty form-control"
                              name="titulName"
                              v-validate.initial="'required|min:1|max:512'"
                              placeholder="Titulaire de la carte"
                              autocomplete="cc-titulName"
                              required autofocus
                            />
                            <span v-show="titulName!=null && errors.has('errorsCard.titulName')" class="help-block">Le nom du titulaire ne peut être vide</span>
                          </div>
                        </div>

                        <div class="col-xs-12 card-element">
                          <label for="cardNumber">Numéro de la carte</label>
                          <div id="cardNumber" class="field empty"></div>
                        </div>

                        <div class="col-xs-7 col-md-7 pull-left card-element">
                          <label for="cardExpiry">Date d'expiration MM/AA</label>
                          <div id="cardExpiry" class="field empty"></div>
                        </div>

                        <div class="col-xs-5 col-md-5 pull-left card-element">
                          <label for="cardCVC">Code de sécurité (CVC/CVV)</label>
                          <div id="cardCVC" class="field empty"></div>
                        </div>

                        <div class="col-xs-12">
                          <div id="card-errors" role="alert">
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </form>
              </b-card>
            </b-collapse>
          </div>
        </div>

        <div class="col-md-12 " v-if="!stripeOutOfService">
          <div class="col-md-1">
            <div class="check" @click.prevent="checkPayementElectronique('bancontact')">
              <div class="checkInside" v-if="modePayement=='payementElectronique' && sousModePayement=='bancontact'">
                <span class="fa fa-check" style="color:white"></span>
              </div>
            </div>
            <!--              <input type="checkbox" :checked="livraisonByAdresse" value="adresse" name="deliveryType" class="hidden-radio">-->
          </div>
          <div class="col-md-11">
            <div @click.prevent="checkPayementElectronique('bancontact')" class="info-box-content">
              <span class="info-box-number">Paiement électronique sécurisé</span>
              <div class="technical-hide-when-opened" style="display: inline;">
                Payer par Bancontact
                <div class="iconsPaymentMethodCard">
                  <img src="../../assets/img/icons/icon_checkout_bancontact.png">
                </div>
                <div>
                  <img src="../../assets/img/logos/powered_by_stripe.png" style="margin-top: 10px;" alt="">
                </div>
                <span style="color: #7c7c7c; font-size: 12px  ;">
                  Tous les paiements électroniques sont effectués via notre partenaire Stripe via une connexion SSL sécurisée.<br/>
                </span>
              </div>

            </div>
          </div>
          <div class="col-md-12 credit_card">
            <b-collapse visible v-model="modePayementIsBancontact" style="margin-top: 20px;"
                        class="">
              <b-card>
                <form data-vv-scope="errorsBancontact" @submit.prevent="">
                  <div class="col-md-12">
                    <div class="panel panel-default credit-card-box">
                      <div class="panel-heading display-table">
                        <div class="display-tr">
                          <h3 class="panel-title display-td">Informations de payement</h3>
                          <span class="small">Ces données ne transitent pas via les serveurs de l'A.B.F.T.
                          Nous n'enregistrons aucune donnée liée à votre moyen de payement.</span>
                        </div>
                      </div>
                      <div class="panel-body">

                        <div class="col-xs-12 card-element">
                          <div class="form-group"
                               :class="{'has-error': titulNameBancontact!=null && errors.has('errorsBancontact.titulNameBancontact') }">
                            <label for="titulName">Nom du titulaire de la carte</label>
                            <input
                              type="text"
                              ref="titulNameBancontact"
                              id="titulNameBancontact"
                              v-model="titulNameBancontact"
                              class="field empty form-control"
                              name="titulNameBancontact"
                              v-validate.initial="'required|min:1|max:512'"
                              placeholder="Titulaire de la carte"
                              autocomplete="cc-titulName"
                              required autofocus
                            />
                            <span v-show="titulNameBancontact!=null && errors.has('errorsBancontact.titulNameBancontact')" class="help-block">Le nom du titulaire ne peut être vide</span>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </form>
              </b-card>
            </b-collapse>
          </div>
        </div>


        <br>


      </div>

      <div class="row no-print" style="margin-bottom: 0">
        <hr>
        <div class="col-xs-12">
          <button type="button" class="btn btn-primary pull-right"
                  @click.prevent="submitForm"
                  :disabled="modePayement==null ||
                  disabledBtn ||
                  !verifAdresseForm() ||
                  (!stripeOutOfService && modePayement=='payementElectronique' && sousModePayement!='bancontact' && this.errors.has('errorsCard.titulName')) ||
                  (!stripeOutOfService && modePayement=='payementElectronique' && sousModePayement=='bancontact'&& this.errors.has('errorsBancontact.titulNameBancontact') )
                  ">
            <i class="fa fa-credit-card"></i>
            Utiliser ce moyen de payement
          </button>
        </div>

        <div class="col-xs-12">
          <small style="color: #7c7c7c; font-size: 12px; margin-top: 20px; float:right">Vous pourrez vérifier votre
            commande à la prochaine étape avant d'effectuer le
            payement.</small>
        </div>
      </div>
    </section>
  </div>
</template>

<script type="text/babel">
import Auth from '@/auth'
import {mapGetters, mapActions} from 'vuex'
import stepsOrder from '../stepsOrder'

let _ = require('lodash')
// import { stripeKey, stripeOptions } from './stripeConfig.json'
// import {Card, createToken} from 'vue-stripe-elements-plus'

export default {
  data() {
    return {
      complete: false,
      stripeOutOfService: false,
      loading: false,
      facturationAdresse: false,
      modePayement: null,
      sousModePayement: null,
      elements: null,
      card: null,
      cardNumberElement: null,
      cardExpiryElement: null,
      cardeCVCElement: null,
      disabledBtn: false,
      // cardTest: {
      // numCarte: process.env.NODE_ENV == 'development' ? process.env.numCarte : null,
      titulName: null,
      titulNameBancontact: null,
      // expDate: process.env.NODE_ENV == 'development' ? process.env.expDate : null,
      // cardCVC: process.env.NODE_ENV == 'development' ? process.env.cardCVC : null,
      // tokenStripe: null
      // },

      adresse: {
        mail: "",
        nom: "",
        prenom: "",
        adresse: "",
        complement: "",
        cp: "",
        ville: "",
        telephone_gsm: "",
      }
    }
  },
  created: function () {

  },
  mounted: function () {
    this.$nextTick(() => {
      if (!this.getStripeObject) {
        this.stripeOutOfService = true
        this.$noty.warning("Notre partenaire de payement en ligne n'est pas disponible dans l'immédiat. Seules les commandes par virement sont autorisées.",
          {
            type: "warning",
            timeout: false
          });
      } else
        this.elements = this.getStripeObject.elements();

      this.setAdresse();

      const style = {
        base: {
          iconColor: '#555',
          color: '#555',
          lineHeight: '48px',
          fontWeight: 400,
          fontFamily: '"Open Sans", "Helvetica Neue", "Helvetica", sans-serif',
          fontSize: '15px',
          border: '1px solid #555',
          '::placeholder': {
            color: '#CFD7DF',
          },
          ':focus': {
            color: '#424770',
          },
          ':focus::placeholder': {
            color: '#CFD7DF',
          },
        },
        invalid: {
          color: '#E25950',
          ':focus': {
            color: '#FA755A',
          },
          '::placeholder': {
            color: '#FFCCA5',
          },
        },
      }
      let elementClasses = {
        focus: 'focus',
        empty: 'empty',
        invalid: 'invalid',
      };

      if (this.getStripeObject) {
        this.cardNumberElement = this.elements.create('cardNumber', {
          style: style,
          showIcon: true,
          placeholder: 'Numéro de carte',
          classes: elementClasses
        });
        this.cardExpiryElement = this.elements.create('cardExpiry', {
          style: style,
          placeholder: "MM/AA",
          classes: elementClasses
        });
        this.cardeCVCElement = this.elements.create('cardCvc', {
          style: style,
          placeholder: 'CVC',
          classes: elementClasses
        });

        this.cardNumberElement.mount('#cardNumber');
        this.cardExpiryElement.mount('#cardExpiry');
        this.cardeCVCElement.mount('#cardCVC');

        this.cardNumberElement.on('focus', (event) => {
          document.querySelector("#cardNumber").classList.add('focused')
        });
        this.cardExpiryElement.on('focus', (event) => {
          document.querySelector("#cardExpiry").classList.add('focused')
        });
        this.cardeCVCElement.on('focus', (event) => {
          document.querySelector("#cardCVC").classList.add('focused')
        });

        this.cardNumberElement.on('blur', (event) => {
          document.querySelector("#cardNumber").classList.remove('focused')
        });
        this.cardExpiryElement.on('blur', (event) => {
          document.querySelector("#cardExpiry").classList.remove('focused')
        });
        this.cardeCVCElement.on('blur', (event) => {
          document.querySelector("#cardCVC").classList.remove('focused')
        });
      }
    })
  },
  methods: {
    ...mapActions({
      setModePayement: 'setModePayement',
      setSousModePayement: 'setSousModePayement',
      setAdresseFacturationForOrder: 'setAdresseFacturationForOrder',
      setStepOrder: 'setStepOrder',
      setLoading: 'setLoading',
      setIdOrder: 'setIdOrder',
      setStripeClientSecretToken: 'setStripeClientSecretToken',
      setStripePaymentMethod: 'setStripePaymentMethod',
      setTitulCardName: 'setTitulCardName',
    }),
    checkPayementElectronique: function (typeSousMode = "card") {
      this.modePayement = 'payementElectronique'
      this.sousModePayement = typeSousMode
    },
    checkVirement: function (typeSousMode = "card") {
      this.modePayement = 'virement'
      this.sousModePayement = "card"
    },
    getCreatePayementIntentObject: function () {
      return {
        id_club: this.getIdClubSelected,
        typePayement: this.modePayement == "payementElectronique" ? this.sousModePayement : null,
        details: {
          shipping: {
            carrier: "BPOST",
            name: this.getOrder.adresseFacturationForOrder.nom + " " + this.getOrder.adresseFacturationForOrder.prenom,
            address: {
              city: this.getOrder.adresseFacturationForOrder.ville,
              country: "BE",
              line1: this.getOrder.adresseFacturationForOrder.adresse,
              postal_code: this.getOrder.adresseFacturationForOrder.cp
            }
          },
          receipt_email: this.getOrder.adresseFacturationForOrder.mail ? this.getOrder.adresseFacturationForOrder.mail : null
        }
      }
    },
    submitForm: function () {
      if (this.disabledBtn)
        return
      this.disabledBtn = true

      this.createOrder()
        .then(() => this.createPaymentMethod())
        .then(() => this.goToConfirm())
        .catch(() => {
          this.setLoading(false)
          this.disabledBtn = false
        })
    },
    createOrder: async function () {
      return await this.$http.post(process.env.API_URL + "createOrder",
        {...this.prepareCreateOrderObject(), ...this.getCreatePayementIntentObject()})
        .then((response) => {
          this.setLoading(false)
          if (this.modePayement == 'payementElectronique') {
            this.setIdOrder(response.body.id_order)
            this.setStripeClientSecretToken(response.body.stripe_token)
          } else if (this.modePayement == 'virement')
            this.setIdOrder(response.body.id_order)
          return true
        }, (error) => {
          this.loading = false
          this.$noty.error("Erreur lors de la création de votre commande. ERR402")
          throw TypeError("Erreur lors de la création de votre commande. ERR402");
          return false
        })
    },
    prepareCreateOrderObject: function () {
      let adresseOrder = this.getOrder.adresseForOrder.nom + " " +
        this.getOrder.adresseForOrder.prenom + "\n" +
        this.getOrder.adresseForOrder.complement + " " +
        this.getOrder.adresseForOrder.adresse + "\n" +
        this.getOrder.adresseForOrder.cp + "" +
        this.getOrder.adresseForOrder.ville /*+ "\n" +
        this.getOrder.adresseForOrder.mail;*/
      let adresseFacturationOrder = this.getOrder.adresseFacturationForOrder.nom + " " +
        this.getOrder.adresseFacturationForOrder.prenom + "\n" +
        this.getOrder.adresseFacturationForOrder.complement + " " +
        this.getOrder.adresseFacturationForOrder.adresse + "\n" +
        this.getOrder.adresseFacturationForOrder.cp + " " +
        this.getOrder.adresseFacturationForOrder.ville + "\n" +
        this.getOrder.adresseFacturationForOrder.mail;

      return {
        id_club: this.getIdClubSelected,
        mode_payement: this.getOrder.modePayement,
        mode_livraison: this.getOrder.modeLivraison,
        adresse_livraison: adresseOrder,
        adresse_facturation: adresseFacturationOrder,
        json_details: JSON.stringify(this.getOrder),
        products: {
          renew: _.map(this.getCart.licence_renew, (item) => {
            return {
              id_product: "eyJpdiI6IlczYWdnVWo0MFI5ZVNKemNOcHg0MkE9PSIsInZhbHVlIjoiOFpxOGtcL201V2tjZCtyM1BneXd4SGc9PSIsIm1hYyI6IjUwNGIzMThjMjcwOGYzZDZmN2FkMDg0YzQ4NzhjNGViMjJmZmUwNTQ4Mjg5YzA1MDY1ZDJkN2RlNGU2ODhjZTUifQ==",
              ordereableId: item.member.id
            }
          }),

          licence_club: _.map(this.getCart.licence_club, (item) => {
            return {
              id_product: "eyJpdiI6IklcL2JDREVQWXBVaTUwcUxLZThHaTF3PT0iLCJ2YWx1ZSI6ImgxXC85VUl4bTZRWm1saE9LV0lyRjZBPT0iLCJtYWMiOiJlZTI3MmJlYTU4NDlmZGM1OGQwOGFhZThmYzBlZWI1YzQxYzAyN2Y4NmM3YzMyMGYwYTQ4YzUxOTRkMjMzYzU1In0=",
              ordereableId: item.id
            }
          })
        }
      }
    },

    createPaymentMethod: async function () {
      if (this.modePayement == "payementElectronique" && this.sousModePayement == "card") {
        const cardElement = this.elements.getElement('cardNumber');
        return await this.getStripeObject.createPaymentMethod({
          type: "card",
          card: cardElement,
          billing_details: {
            name: this.getOrder.adresseFacturationForOrder.nom + " " + this.getOrder.adresseFacturationForOrder.prenom,
            email: this.getOrder.adresseFacturationForOrder.mail ? this.getOrder.adresseFacturationForOrder.mail : null,
            address: {
              city: this.getOrder.adresseFacturationForOrder.ville,
              country: "BE",
              line1: this.getOrder.adresseFacturationForOrder.adresse,
              postal_code: this.getOrder.adresseFacturationForOrder.cp
            }
          },
        }).then((result) => {
          if (result.paymentMethod) {
            this.setStripePaymentMethod(result)
            this.cardNumberElement.clear()
            this.cardExpiryElement.clear()
            this.cardeCVCElement.clear()
            return true
          }

          if (result.error) {
            this.$noty.error("Erreur dans la validation de votre moyen de payement. ERR103")
            throw TypeError("Erreur dans la validation de votre moyen de payement. ERR103");
            return false
          }
        })

      }
      return false
    },

    goToConfirm: function () {
      if (this.modePayement == 'payementElectronique') {
        this.setLoading(true)
        this.setStepOrder({step: 'step3', value: true})
        if (this.getStripePaymentMethod && this.getStripeClientSecretToken && this.sousModePayement == 'card')
          this.$router.push({name: 'Confirm'})
        else if (this.getStripeClientSecretToken && this.sousModePayement == 'bancontact')
          this.$router.push({name: 'Confirm'})
        else {
          this.$noty.error("Erreur de connexion avec l'organisme de payement sécurisé. Veuillez réessayer plus tard. ERR101")
          throw TypeError("Erreur de connexion avec l'organisme de payement sécurisé. Veuillez réessayer plus tard. ERR101");
          return false
        }
      } else {
        this.setStepOrder({step: 'step3', value: true})
        this.setLoading(false)
        this.$router.push({name: 'Confirm'})
        return true
      }
      return false
    },

    setAdresse: function () {
      this.adresse = {
        mail: this.getMember.mail ? this.getMember.mail : "",
        nom: this.getMember.nom ? this.getMember.nom : "",
        prenom: this.getMember.prenom ? this.getMember.prenom : "",
        adresse: this.getMember.adresse ? this.getMember.adresse : "",
        complement: this.getMember.complement ? this.getMember.complement : "",
        cp: this.getMember.cp ? this.getMember.cp : "",
        ville: this.getMember.ville ? this.getMember.ville : "",
        telephone_gsm: this.getMember.telephone_gsm ? this.getMember.telephone_gsm : "",
      }
    },
    verifAdresseForm: function () {

      let keysToVerif = [
        "mail",
        "nom",
        "prenom",
        "adresse",
        // "complement",
        "cp",
        "ville",
        // "telephone_gsm"
      ]
      let retour = true
      keysToVerif.forEach((item, index) => {
        if (_.trim(this.adresse[item]) == '')
          retour = false
      })
      return retour
    },

  },
  watch: {
    'adresse': function () {
      this.setAdresseFacturationForOrder(this.adresse)
    },
    'titulName': function () {
      this.setTitulCardName(this.titulName)
    },
    'titulNameBancontact': function () {
      this.setTitulCardName(this.titulNameBancontact)
    },
    'modePayement': function () {
      this.setModePayement(this.modePayement)
    },
    'sousModePayement': function () {
      this.setSousModePayement(this.sousModePayement)
    },
  },
  components: {
    stepsOrder,
  },
  computed: {
    modePayementIsElectronique: {
      get() {
        return this.modePayement == 'payementElectronique' && this.sousModePayement == 'card'
      },
      set() {

      }
    },
    modePayementIsBancontact: {
      get() {
        return this.modePayement == 'payementElectronique' && this.sousModePayement == 'bancontact'
      },
      set() {

      }
    },
    ...mapGetters({
      getCart: 'getCart',
      getOrder: 'getOrder',
      getMember: 'getMember',
      getIdClubSelected: 'getIdClubSelected',
      getStripePaymentMethod: 'getStripePaymentMethod',
      getStripeClientSecretToken: 'getStripeClientSecretToken',
      getStripeObject: 'getStripeObject',
    })
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Order/ChoixModePayement.vue